import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetPropertyImageAnalysisError,
  GetPropertyImageAnalysisVariables,
  fetchGetPropertyImageAnalysis,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getPropertyImageAnalysis;

export function useGetPropertyImageAnalysis(
  variables: GetPropertyImageAnalysisVariables,
  opts?: UseQueryOptions<Response, GetPropertyImageAnalysisError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetPropertyImageAnalysisError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}/property/{propertyID}/imageAnalysis',
      operationId: 'getPropertyImageAnalysis',
      variables,
    }),
    async () => {
      const res = await fetchGetPropertyImageAnalysis({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
